import forEach from 'lodash/forEach'
//
// Initialize
//
document.addEventListener('DOMContentLoaded', () => {
  const menuMobile = document.querySelector('.header__nav')
  const superDom = document.querySelector('html')
  const buttons = document.querySelector('.header__buttons')
  const firstButton = buttons?.firstChild
  const content = document.querySelector('.content')

  const setPaddingTop = (value) => {
    if (content) {
      content.style.paddingTop = value
    }
  }

  firstButton?.classList.remove('c-button--secondary')
  firstButton?.classList.add('c-button--reverseSecondary')

  forEach(document.querySelectorAll('.menu'), (root) => {
    root.addEventListener('click', () => {
      menuMobile.classList.add('hb-open')
      superDom.classList.add('menu-open-custom')
      document.querySelector('header').classList.add('hb-open')
      setPaddingTop('0')
      // To IOS click events
      document.addEventListener('touchstart', () => {}, true)
    })
  })

  forEach(document.querySelectorAll('.close-menu'), (root) => {
    root.addEventListener('click', () => {
      menuMobile.classList.remove('hb-open')
      superDom.classList.remove('menu-open-custom')
      document.querySelector('header').classList.remove('hb-open')
      setPaddingTop('')
      // To IOS click events
      document.removeEventListener('touchstart', () => {}, true)
    })
  })

  document.addEventListener('click', (event) => {
    if (menuMobile && !menuMobile.contains(event.target) && !event.target.closest('.menu')) {
      menuMobile.classList.remove('hb-open')
      superDom.classList.remove('menu-open-custom')
      document.querySelector('header').classList.remove('hb-open')
      setPaddingTop('')
      // To IOS click events
      document.removeEventListener('touchstart', () => {}, true)
    }
  })
})
